import React from "react";

import { BSBtn, BSCard } from "traec-react/utils/bootstrap";
import { ProjectPermission } from "../utils/permissions";

import useApi, { doFetch } from "storybook-dashboard/utils/fetching";
import { Modal, useModal } from "storybook-dashboard/components/modal";
import DataTable from "react-data-table-component";
import Im from "immutable";
import { ActionIcon } from "./utils";
import { formEventToData } from "./utils";
import { useProjectPermissions } from "storybook-dashboard/utils/hooks";
import { Hide } from "../../utils";
import Octicon from "react-octicon";

const createOrUpdateDiscipline = (e, { item, hideModal, projectId, trigger }) => {
  let data = formEventToData(e);

  if (!data.approver) {
    data.approver = null;
  }

  console.log("createOrUpdateDiscipline", e, data, item?.toJS());

  let url = `/api/project/${projectId}/discipline/` + (item ? `${item?.get("uid")}/` : "");
  let method = item ? "PATCH" : "POST";
  doFetch(url, method, data).then(() => {
    if (trigger) trigger();
    if (hideModal) hideModal();
  });
};

const deleteDiscipline = ({ item, projectId, trigger }) => {
  let disciplineId = item.get("uid");
  console.log("Deleting discipline", item?.toJS());

  doFetch(`/api/project/${projectId}/discipline/${disciplineId}/`, "DELETE").then(() => {
    if (trigger) trigger();
  });
};

function DeleteRoleConfirmationModal({ role, onConfirm, onCancel }) {
  const roleName = role.get("name", "");
  const permissions = role.getIn(["auth", "name"], "No permissions assigned");
  const reportsTo = role.getIn(["approver", "name"], "No supervisor");
  const hierarchyLevel = role.getIn(["_ancestry", "level"], 1);

  return (
    <Modal title="Delete Role">
      <div className="p-3">
        <div className="d-flex align-items-start mb-3">
          <div className="text-warning me-3 mt-1">
            <Octicon name="alert" style={{ fontSize: "24px" }} />
          </div>
          <div>
            <h6 className="mb-2">Are you sure you want to delete this role?</h6>
            <p className="text-muted mb-3">
              This action will permanently delete the role and remove it from the project hierarchy. Any users assigned
              to this role will lose their role assignment.
            </p>
          </div>
        </div>

        <div className="card bg-light border-0 mb-3">
          <div className="card-body py-3">
            <div className="row">
              <div className="col-sm-4">
                <small className="text-muted d-block">Role Name</small>
                <strong>{roleName}</strong>
                {hierarchyLevel > 1 && <small className="text-muted d-block">↳ Subordinate role</small>}
              </div>
              <div className="col-sm-4">
                <small className="text-muted d-block">Reports To</small>
                <span className={reportsTo === "No supervisor" ? "text-muted" : "badge bg-light text-dark"}>
                  {reportsTo}
                </span>
              </div>
              <div className="col-sm-4">
                <small className="text-muted d-block">Permissions</small>
                <span className={permissions === "No permissions assigned" ? "text-muted" : "badge bg-info text-white"}>
                  {permissions}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="alert alert-danger d-flex align-items-start">
          <Octicon name="stop" className="me-2 mt-1" style={{ fontSize: "16px" }} />
          <div>
            <strong>Warning:</strong> This will affect any users currently assigned to this role. They will lose their
            role-based permissions and hierarchy position within the project.
          </div>
        </div>

        <div className="d-flex gap-2 justify-content-end">
          <button className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={onConfirm}>
            <Octicon name="trashcan" className="me-2" />
            Delete Role
          </button>
        </div>
      </div>
    </Modal>
  );
}

function CreateOrEditNewDisciplineModal(props) {
  let { item, authgroups, disciplines, hideModal } = props;
  return (
    <Modal title={item ? "Edit Role" : "Add New Role"}>
      <div className="p-3">
        <p className="text-muted mb-3">
          {item
            ? "Update the role details below."
            : "Create a new project role with specific permissions and approval hierarchy."}
        </p>
        <form onSubmit={(e) => createOrUpdateDiscipline(e, props)}>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group mb-3">
                <label htmlFor="dName" className="form-label">
                  Role Name
                </label>
                <input
                  className="form-control"
                  name="name"
                  id="dName"
                  placeholder="Enter role name"
                  defaultValue={item?.get("name") || ""}
                  required
                />
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group mb-3">
                <label htmlFor="dAuth" className="form-label">
                  Permissions
                </label>
                <select name="auth" className="form-control" defaultValue={item?.getIn(["auth", "uid"]) || ""}>
                  <option value="">Select permissions...</option>
                  {(authgroups || Im.List()).map((i, k) => (
                    <option key={k} value={i.get("uid")}>
                      {i.get("name")}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-sm-3">
              <div className="form-group mb-3">
                <label htmlFor="dApprover" className="form-label">
                  Reporting To
                </label>
                <select name="approver" className="form-control" defaultValue={item?.getIn(["approver", "uid"]) || ""}>
                  <option value="">No supervisor</option>
                  {(disciplines || Im.List()).map((i, k) => (
                    <option key={k} value={i.get("uid")}>
                      {i.get("name")}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-primary" type="submit">
              <Octicon name="check" className="me-2" />
              {item ? "Update Role" : "Create Role"}
            </button>
            <button className="btn btn-secondary" type="button" onClick={hideModal}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

const getColumns = (props) => {
  let { setModal, isAdmin } = props;
  return [
    {
      name: "Role Name",
      sortable: true,
      selector: (item) => item.get("name"),
      grow: 2,
      wrap: true,
      cell: (item) => (
        <div className="d-flex flex-column">
          <span className="fw-medium" style={{ marginLeft: `${(item.getIn(["_ancestry", "level"]) - 1) * 1.5}rem` }}>
            {item.get("name")}
          </span>
          {item.getIn(["_ancestry", "level"]) > 1 && <small className="text-muted">↳ Subordinate role</small>}
        </div>
      ),
    },
    {
      name: "Reports To",
      sortable: true,
      selector: (item) => item.getIn(["approver", "name"]) || "No supervisor",
      grow: 1,
      wrap: true,
      cell: (item) => {
        const approverName = item.getIn(["approver", "name"]);
        return approverName ? (
          <span className="badge bg-light text-dark">{approverName}</span>
        ) : (
          <span className="text-muted">No supervisor</span>
        );
      },
    },
    {
      name: "Permissions",
      sortable: true,
      selector: (item) => item.getIn(["auth", "name"]) || "No permissions",
      grow: 1,
      wrap: true,
      cell: (item) => {
        const authName = item.getIn(["auth", "name"]);
        return authName ? (
          <span className="badge bg-info text-white">{authName}</span>
        ) : (
          <span className="text-muted">No permissions</span>
        );
      },
    },
    {
      name: "Actions",
      cell: (item) => (
        <Hide when={!isAdmin}>
          <div className="d-flex gap-1">
            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() => setModal(<CreateOrEditNewDisciplineModal {...props} item={item} />)}
              title="Edit Role"
            >
              <Octicon name="pencil" />
            </button>
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => props.onDeleteRole && props.onDeleteRole(item)}
              title="Delete Role"
            >
              <Octicon name="trashcan" />
            </button>
          </div>
        </Hide>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "120px",
    },
  ];
};

const getAncestry = (discipline, disciplinesById) => {
  if (!discipline) return Im.Map({ path: Im.List(), level: 0 });
  let approverId = discipline.get("approver");
  let approver = approverId ? disciplinesById.get(approverId) : null;

  let details = getAncestry(approver, disciplinesById);

  return Im.Map({
    path: details.get("path").push(discipline.get("uid")),
    level: details.get("level") + 1,
  });
};

function ProjectRolesHeader({ projectId, roleCount, isLoading }) {
  const { data: project } = useApi(`/api/project/{projectId}/`, { projectId });

  return (
    <div className="card shadow-sm mb-4">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <div className="d-flex align-items-center mb-2">
              <h1 className="h3 mb-0 text-primary">Project Roles</h1>
            </div>
            <p className="text-muted mb-2">{project?.get("name")}</p>
            {!isLoading && (
              <p className="text-muted small mb-0">
                <strong>Total roles:</strong> {roleCount}
              </p>
            )}
          </div>
          <div className="text-end">
            <span className="badge badge-primary">Role Management</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function RolesDescription() {
  return (
    <div className="mb-4">
      <h2 className="h4 text-dark mb-2">Role & Hierarchy Management</h2>
      <p className="text-muted">
        Define project roles and their reporting relationships. Each role can have specific permissions and can report
        to other roles, creating an organisational hierarchy within the project.
      </p>
      <div className="alert alert-info">
        <div className="d-flex">
          <Octicon name="organization" className="me-2 mt-1" />
          <div>
            <strong>Role Hierarchy:</strong> Roles can be organised in a hierarchy where team members report to
            supervisors. This helps manage approval workflows and responsibility chains within the project.
          </div>
        </div>
      </div>
    </div>
  );
}

export default function DisciplineList({ projectId }) {
  let { setModal, hideModal } = useModal();
  let { isAdmin } = useProjectPermissions();
  let { data: disciplines, trigger, isLoading } = useApi("/api/project/{projectId}/discipline/", { projectId });
  let { data: authgroups } = useApi("/api/project/{projectId}/authgroup/", { projectId });

  const handleDeleteRole = (role) => {
    setModal(
      <DeleteRoleConfirmationModal
        role={role}
        onConfirm={() => {
          deleteDiscipline({ item: role, projectId, trigger });
          hideModal();
        }}
        onCancel={hideModal}
      />
    );
  };

  // Nest the approver and any disciplines that are approved
  let disciplinesById = disciplines?.reduce((a, i) => a.set(i.get("uid"), i), Im.Map());
  let _disciplines = disciplines
    ?.map(
      (i) =>
        i //
          .set("approver", disciplinesById.get(i.get("approver"))) // Set the full approver object
          .set("_ancestry", getAncestry(i, disciplinesById)) // Get the ancestry
    )
    ?.sortBy((i) => i.getIn(["_ancestry", "path"]));

  const roleCount = _disciplines?.size || 0;

  console.log("DisciplineList", _disciplines?.toJS());

  let _props = {
    disciplines,
    authgroups,
    setModal,
    hideModal,
    projectId,
    trigger,
    isAdmin,
    onDeleteRole: handleDeleteRole,
  };

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <ProjectRolesHeader projectId={projectId} roleCount={roleCount} isLoading={isLoading} />

          <div className="card shadow-sm">
            <div className="card-body">
              <RolesDescription />

              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h5 className="mb-0">Project Roles</h5>
                </div>
                <ProjectPermission projectId={projectId} requiresAdmin={true}>
                  <button
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={() => setModal(<CreateOrEditNewDisciplineModal {..._props} projectId={projectId} />)}
                  >
                    <Octicon name="plus" />
                    Add New Role
                  </button>
                </ProjectPermission>
              </div>

              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center py-5">
                  <div className="spinner-border text-primary me-3 mr-3" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <span className="text-muted">Loading roles...</span>
                </div>
              ) : (
                <div className="table-responsive">
                  <DataTable
                    columns={getColumns(_props)}
                    data={_disciplines?.toArray() || []}
                    highlightOnHover={true}
                    pagination={roleCount > 25}
                    paginationPerPage={25}
                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    noDataComponent={
                      <div className="text-center py-5">
                        <Octicon name="organization" className="text-muted mb-3" style={{ fontSize: "48px" }} />
                        <h5 className="text-muted">No roles defined</h5>
                        <p className="text-muted">
                          This project doesn't have any roles yet. Start by creating your first project role.
                        </p>
                        <ProjectPermission projectId={projectId} requiresAdmin={true}>
                          <button
                            className="btn btn-outline-primary"
                            onClick={() =>
                              setModal(<CreateOrEditNewDisciplineModal {..._props} projectId={projectId} />)
                            }
                          >
                            <Octicon name="plus" className="me-2" />
                            Create First Role
                          </button>
                        </ProjectPermission>
                      </div>
                    }
                    customStyles={{
                      table: {
                        style: {
                          borderRadius: "8px",
                        },
                      },
                      headRow: {
                        style: {
                          backgroundColor: "#f8f9fa",
                          borderTopLeftRadius: "8px",
                          borderTopRightRadius: "8px",
                        },
                      },
                      rows: {
                        style: {
                          "&:hover": {
                            backgroundColor: "#f8f9fa",
                            cursor: "pointer",
                          },
                        },
                      },
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
